export const REQUEST_CAREER = "REQUEST_CAREER";
export const RECEIVED_CAREER = "RECEIVED_CAREER";
export const ERROR_CAREER = "ERROR_CAREER";

export const CAREER_NONE = "CAREER_NONE";
export const CAREER_REQUESTING = "CAREER_REQUESTING";
export const CAREER_RECEIVED = "CAREER_RECEIVED";
export const CAREER_ERROR = "CAREER_ERROR";
